import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';
import RadioButton from 'components/RadioButton';
import UppercaseText from 'components/UppercaseText';

import './styles.css';

const GOCARDLESS_INVITATION_RADIO_BUTTON = 'gocardlessInvitation';

const TenantRow = ({customer, role, isSelected, onSelect}) => (
  <div className="TenantRow colab-centered-v">
    <div className="role colab-centered-v">
      <RadioButton
        name={GOCARDLESS_INVITATION_RADIO_BUTTON}
        value={customer.id}
        checked={isSelected}
        onChange={() => onSelect(customer.id)}
      />
      <div className="colab-bold">{role}</div>
    </div>
    <div className="name">{customer.fullName}</div>
    <div className="email">{customer.email}</div>
  </div>
);

interface TenantProps {
  id: number;
  fullName: string;
  email: string;
}

interface SendInvitationProps {
  tenantsPerBooking: {
    primaryTenant: TenantProps;
    secondaryTenant?: TenantProps;
  };
  openSendGoCardlessInvitationWarningsModal: Function;
}

interface SendInvitationState {
  selectedRow: {
    id: number | null;
  };
}

class SendInvitation extends React.Component<
  SendInvitationProps,
  SendInvitationState
> {
  state = {
    selectedRow: {id: null}
  };

  selectCustomer = customerId => {
    this.setState({selectedRow: {id: customerId}});
  };

  render() {
    const {selectedRow} = this.state;
    const {tenantsPerBooking} = this.props;

    return (
      <div className="SendInvitation">
        <div className="content">
          <UppercaseText>Send new invite</UppercaseText>
          {!_.isEmpty(tenantsPerBooking) && (
            <React.Fragment>
              <TenantRow
                key={tenantsPerBooking.primaryTenant.id}
                customer={tenantsPerBooking.primaryTenant}
                onSelect={this.selectCustomer}
                isSelected={
                  selectedRow.id === tenantsPerBooking.primaryTenant.id
                }
                role="Primary tenant"
              />
              {tenantsPerBooking.secondaryTenant && (
                <TenantRow
                  key={tenantsPerBooking.secondaryTenant.id}
                  customer={tenantsPerBooking.secondaryTenant}
                  onSelect={this.selectCustomer}
                  isSelected={
                    selectedRow.id === tenantsPerBooking.secondaryTenant.id
                  }
                  role="Secondary"
                />
              )}
            </React.Fragment>
          )}
        </div>
        <div className="actionButton">
          <Button
            blue
            onClick={() =>
              this.props.openSendGoCardlessInvitationWarningsModal(
                selectedRow.id
              )
            }
            disabled={_.isNil(selectedRow.id)}>
            Send
          </Button>
        </div>
      </div>
    );
  }
}

export default SendInvitation;
